import { Component, inject } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";
import { NgClickOutsideDirective } from "ng-click-outside2";
import { DialogIPPrefixesRequestComponent } from "../../../../components/dialogs/dialog-ip-prefixes-request/dialog-ip-prefixes-request";
import { DialogIPPrefixesAddComponent } from "../../../../components/dialogs/dialog-ip-prefixes-add/dialog-ip-prefixes-add";
import { MatDialog } from "@angular/material/dialog";
import { ComponentType } from "@angular/cdk/overlay";

@Component({
  selector: "request-add-prefix",
  templateUrl: "request-add-prefix.html",
  styleUrls: ["../../ip-prefixes.scss"],
  imports: [AngularSvgIconModule, NgClickOutsideDirective, TranslateModule],
})
export class RequestAddPrefix {
  private dialog = inject(MatDialog);

  protected overflowMenuIPActive: boolean;

  private openPrefixDialog(event: Event, component: ComponentType<any>) {
    event.stopPropagation();
    event.preventDefault();
    this.dialog.open(component, { disableClose: true });
    return false;
  }

  protected openRequestPrefixDialog = (event: Event) => this.openPrefixDialog(event, DialogIPPrefixesRequestComponent);
  protected openAddPrefixDialog = (event: Event) => this.openPrefixDialog(event, DialogIPPrefixesAddComponent);
}
